module.exports = __webpack_public_path__ + "img/Vehicle registration.9ee70f32.jpg";